import Video from "./Video";

/**
 * Call
 */

export default class HtmlVideoPlayer extends Video {
    constructor(element, options)
    {
        super(element, options)

        this.video = element.querySelector('video');

        for (let option in this.options)
        {
            let bool = this.options[option];
            switch(option)
            {
                case 'autoplay':
                    this.video.autoplay = bool;
                    bool ? this.play() : this.pause();
                    break;
                case 'loop':
                    this.video.loop = bool;
                    break;
                case 'muted':
                    this.video.muted = this.options[option]
                    bool ? this.mute() : this.setVolume(1)
                    break;
                case 'controls':
                    bool ? '' : this.hideControls()
                case 'progress':
                    if (bool)
                    {
                        this.video.addEventListener('timeupdate', () => this.updateTimeElapsed(this.video.duration, this.video.currentTime));

                        this.getSeek(this.video.duration, this.video.currentTime)
                    } else
                    {
                        this.hideProgress()
                    }
            }
        }
    }
    play(){
        super.play()
        this.video.play();
    }
    mute(){
        super.mute();
        this.video.muted = true;
    }
    restart()
    {
        super.restart();
        this.video.currentTime = this.video.duration * 0.005;
    }
    pause(){
        super.pause()
        this.video.pause()
    }
    setVolume(amount){
        super.setVolume(amount)
        this.video.muted = false;
        this.video.volume = 1;
    }
    setTime(percentage)
    {
        super.setTime(percentage);
        let seconds = Math.max((percentage / 100) * this.video.duration, 0)
        this.video.currentTime = seconds;
    }
}